export const ActivityReportState = [
  {
    id: 1,
    name: 'ACTIVITYREPORTSTATE.DRAFT',
  },
  {
    id: 2,
    name: 'ACTIVITYREPORTSTATE.PUBLISHED',
  },
]
